import { Button, Popover, Position } from '@blueprintjs/core'
import React, { PureComponent, SyntheticEvent } from 'react'
import { emojify } from 'react-emojione'
import { TranslationFunction } from 'react-i18next'

import { identity } from '../../../../app/shared'
import { i18nKeys } from '../../../app.i18n'

import './emoji-selector.scss'

type Props = {
  className?: string
  translate?: TranslationFunction
  onSelect(emoji: string): void
}

const emojis = [
  ['🙂', '😀', '😉', '😎', '😍'],
  ['🙁', '😬', '😩', '😠', '😳'],
  ['🤠', '😇', '💎', '🤡', '👽'],
  ['👍', '🤛', '👎', '🖖', '💪'],
  ['🔥', '🍀', '🎯', '🌲', '🥇'],
  ['😼', '🐰', '🐘', '🐶', '🐼'],
]

export class EmojiSelector extends PureComponent<Props> {
  render() {
    const { onSelect, className, translate = identity } = this.props

    const emojirowRender = (emojiRow: string[]) => {
      return emojiRow.map((emoji) => (
        // tslint:disable-next-line:jsx-no-lambda
        <Button onClick={() => onSelect(emoji)} key={`e-${emoji}`} className="bp3-minimal emoji-selector__button">
          {emojify(emoji, { output: 'unicode' })}
        </Button>
      ))
    }

    return (
      <Popover className={className} position={Position.TOP}>
        <button
          onClick={this.handlePopoverButtonClick}
          className="emoji-selector__button ql-emoji"
          title={translate(i18nKeys.frontFace.htmlEditor.emojiTooltip)}
        >
          {'🙂'}
        </button>

        <div>{emojis.map((emojiRow, index) => <div key={`e-${index}`}> {emojirowRender(emojiRow)} </div>)}</div>
      </Popover>
    )
  }

  private handlePopoverButtonClick(ev: SyntheticEvent<HTMLButtonElement>) {
    ev.preventDefault()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/emoji-selector/emoji-selector.component.tsx